import { createAction } from 'redux-actions';
export var putEntities = createAction("@@entities/PUT", function (payload) { return payload; });
//# sourceMappingURL=actions.js.map